import { parse, parseUrl } from 'query-string';
import { LanguageType } from '../../../types/language';
import { NativeApi, Platform } from './interface';
import { getDevLang } from './utils';

// web H5

export const pcWebClient: NativeApi = {
  name: Platform.PCWebClient,
  token: '',
  init(options = {}) {
    const { initLangCallBack } = options;
    const { query } = parseUrl(location.href);
    this.token = (query.token as string) || '';
    initLangCallBack && initLangCallBack(this?.getLanguage() as LanguageType);
  },
  getLanguage: () => {
    const params = parse(location.search);
    return params.lang?.toString().toLocaleLowerCase() || getDevLang();
  },
  closeWindow: () => {},
  gotoWhatsApp: () => {
    location.href = 'https://wa.me/85263692338';
  },
  getToken() {
    return this.token;
  },
};
